export default {
  slices: [
    {
      field: 'ad_categories',
      display: 'Ad Category',
      map: {
        'all_ads': {
          display: 'All Ads',
          sortOrder: 1,
          icon: 'direction_car'
        },
        'brand': {
          display: 'Brand',
          sortOrder: 2,
          icon: 'transport'
        },
        'retail': {
          display: 'Retail',
          sortOrder: 3,
          icon: 'department_stores'
        }
      }
    },
    {
      field: 'ad_type',
      display: 'Media Type',
      map: {
        'tv': {
          display: 'Video',
          sortOrder: 1
        }
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/app/configuration/Genesis/config/metadata.js